<div [formGroup]="form"
     [hidden]="isHidden"
     #field
     class="se-measure--container measure-container">
    <mat-form-field appearance="outline"
                    floatLabel="always"
                    class="se-flex-1-1-auto se-form-field custom-measure"
                    [ngClass]="{'se-measure--out-of-range-accent': !!warningMessage}">
        <mat-label *ngIf="control.isWithLabel"
                   matTooltip="{{control.name}}{{additionalLabelInfo}}">
            {{control.name}}{{additionalLabelInfo}}
        </mat-label>
        <div [matTooltip]="onFocusInputMeasure(inputElement.value)"
             matTooltipClass="mat-tooltip-cp"
             matTooltipShowDelay="500" #tooltipElement>
            <input #inputElement
                   class="se-form-field-input"
                   [ngClass]="{'input-no-label': !control.isWithLabel, 'input-label': control.isWithLabel}"
                   matInput
                   autocomplete="off"
                   [errorStateMatcher]="errorStateMatcher"
                   [formControl]="formControl"
                   [pattern]="pattern"
                   (change)="onMeasureChange()"
                   (focusin)="onFocusIn()"
                   (blur)="onBlur()" />
            <span class="invisible" #invisibleElement [innerHtml]="inputElement.value"></span>
        </div>
        <div matSuffix style="display:flex;">
            <div #unitOfMeasure [matTooltip]="onFocusInputMeasure()"
                 matTooltipClass="mat-tooltip-cp"
                 matTooltipShowDelay="500"
                 class="unit-of-measure mat-mdc-form-field-icon-suffix"
                 [ngClass]="{'hideMeasure' : hideUnitOfMeasure}">{{unitOfMeasureDisplayed}}
            </div>

            <span #measureIcon>
                <mat-icon *ngIf="config?.detailsEnabled" style="vertical-align:middle; margin-left:5px; z-index:99;"
                          [ngClass]="{'cp-measure-pointer': control.config.idPanel}"
                          (click)="onPanelButtonClick()">
                    {{ icon }}
                    <span *ngIf="badgeSource$ | async; let badge" class="mat-badge-content" style="margin-left:-5px"
                          matBadge="{{badge}}" [matBadgeHidden]="(+badge) <= 1" matBadgePosition="before" matBadgeSize="medium"></span>
                </mat-icon>
            </span>
        </div>
    </mat-form-field>
    <div *ngIf="hasAIData" class="measure-ai-label-container">
        <div class="measure-ai-label-content">{{ 'AI' | translate}}</div>
    </div>
</div>

